import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-digital-content-k12',
    templateUrl: './digital-content-k12.component.html',
    styleUrls: ['./digital-content-k12.component.scss']
})
export class DigitalContentK12Component implements OnInit {

    constructor(
        private meta: Meta,
        private titleService: Title,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Digital Content for K-12 Schools | Smart Classroom Solutions by Virsa');
        this.meta.updateTag({
            name: 'description',
            content: 'Transform classrooms with Virsa\'s Interactive Flat Panels and curriculum-aligned digital content for K-12. Improve student engagement, teaching efficiency, and learning outcomes.'
        });
    }
}
